module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01_en.7033fa4eb0e318a4ecbd8d912973402f.png";